var _desc, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMastercard(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "48px",
    height: "30px",
    viewBox: "0 0 48 30",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Card/Mastercard") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "All-Screens",
    stroke: "none",
    strokeWidth: 0,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "WDC-GF03XL",
    transform: "translate(-407.000000, -1026.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-9",
    transform: "translate(240.000000, 256.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-3",
    transform: "translate(37.000000, 668.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Modal",
    transform: "translate(3.000000, 102.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-15"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-22"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Icon/Payment/Mastercard",
    transform: "translate(127.000000, 0.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Card/Visa"
  }, /*#__PURE__*/React.createElement("g", {
    id: "mc_symbol",
    transform: "translate(9.428571, 6.000000)",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group",
    opacity: 0,
    fill: "#FFFFFF"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    x: 0,
    y: 0,
    width: 28.0683696,
    height: 18.5641321
  })), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    fill: "#FF5F00",
    x: 10.3331078,
    y: 3.23430334,
    width: 7.40429021,
    height: 12.0933892
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.095754,9.28206606 C11.0938949,6.92256304 12.1770471,4.69323876 14.0331167,3.2364396 C10.8799466,0.758384698 6.35186783,1.11933482 3.63109252,4.06562393 C0.910317206,7.01191304 0.910317206,11.5543553 3.63109252,14.5006444 C6.35186783,17.4469336 10.8799466,17.8078837 14.0331167,15.3298288 C12.1764565,13.872567 11.093238,11.6423187 11.095754,9.28206606 Z",
    id: "Path",
    fill: "#EB001B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.7419784,14.0480705 L25.7419784,13.8002639 L25.8487916,13.8002639 L25.8487916,13.7489936 L25.5945762,13.7489936 L25.5945762,13.8002639 L25.6949806,13.8002639 L25.6949806,14.0480705 L25.7419784,14.0480705 Z M26.2354553,14.0480705 L26.2354553,13.7489936 L26.1585498,13.7489936 L26.0688267,13.96262 L25.9791036,13.7489936 L25.9021981,13.7489936 L25.9021981,14.0480705 L25.957741,14.0480705 L25.957741,13.8216266 L26.0410553,14.0160266 L26.0987344,14.0160266 L26.1820487,13.8216266 L26.1820487,14.0480705 L26.2354553,14.0480705 Z",
    id: "Shape",
    fill: "#F79E1B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.4768531,9.28206606 C26.4768531,12.2265597 24.7954898,14.9125418 22.1470214,16.1992655 C19.4985531,17.4859891 16.3478845,17.1475531 14.0331167,15.3276925 C15.8883764,13.8696566 16.9716101,11.6406287 16.9716101,9.28099793 C16.9716101,6.92136717 15.8883764,4.69233929 14.0331167,3.23430334 C16.3478845,1.41444271 19.4985531,1.0760067 22.1470214,2.36273039 C24.7954898,3.64945409 26.4768531,6.33543619 26.4768531,9.27992979 L26.4768531,9.28206606 Z",
    id: "Path",
    fill: "#F79E1B"
  })))))))))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMastercard);
export default __webpack_public_path__ + "static/media/mastercard.556fff0e.svg";
export { ForwardRef as ReactComponent };